"use client";

import { adminDeleteArtifacts, AdminDeleteArtifactsData, adminGetArtifacts } from "@/api";
import { appState } from "@/app/appState";
import { chatState } from "@/app/chatState";
import { artifact_list_item } from "@/app/typing/artifacts";
import { usePathParam, useLocalNumberList } from "@/components/path-params";
import { EntryList } from "@/components/UI/tools";
import { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { Request } from "@/components/CRUD";
import { PageBox } from "@/components/UI/page";

const ArtifactsList = observer(() => {
    const [loading, setLoading] = useState(false);

    const [deleting, setDeleting] = useState(false);

    const [artifactSearch, setArtifactSearch] = useState<string>("")

    const [id, setId] = usePathParam("artifacts");
    const [ids, setIds] = useState<number[]>([]);

    const deleteArtifacts = Request<AdminDeleteArtifactsData, any>(
        adminDeleteArtifacts,
        () => ({
            body: {
                ids: ids!,
            },
        }),
        setDeleting,
        (data: any) => {
            appState.artifacts = appState.artifacts?.filter(x => !data.deleted_ids.includes(x.id))
            chatState.forgetDeletedObjects(data.deleted_ids.map((id: number) => ({ type: "artifact", id })))
            setIds([])
        },
        (error) => {
            appState.setModal({
                title: appState.t("common.error"),
                body: appState.t("objects.errorDeleteArtifacts"),
                comment: { name: appState.t("common.detail"), val: error.detail?.toString() ?? "" },
            })
        },
        () => ids != undefined && ids.length > 0,
    )

    useEffect(() => {
        appState.getArtifacts({ pageNumber: 0, search: artifactSearch })
    }, [id, artifactSearch]);



    return (
        <PageBox onScrollToBottom={() => appState.getArtifacts({ pageNumber: appState.artifacts_page + 1, search: artifactSearch })}>

            <div id="artifact" className="h-full w-full">
                <EntryList
                    name={appState.t("objects.list.artifact")}
                    readonly={![4, 5, 6, 7].includes(appState.user?.active_organisation.permission_type ?? 0)}
                    loading={loading}
                    deleting={deleting}
                    search={{ get: artifactSearch, set: setArtifactSearch }}
                    deleteEntries={deleteArtifacts}
                    idParams={{
                        singular: { get: id, set: setId },
                        plural: { get: ids, set: setIds },
                    }}
                    items={appState.artifacts?.filter(x => x.is_draft == false).map((x) => {
                        return { id: x.id, lock: x.user_lock ? !(x.user_lock == appState.user?.id) : false, val: x.variable_name, readonly: ![4, 5, 6, 7].includes(x.permission_type ?? 0), showonly: ![2, 3, 4, 5, 6, 7].includes(x.permission_type ?? 0) };
                    })}
                />
            </div>

        </PageBox>

    );
});

export default ArtifactsList;
